/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".hd--authenticate-progress[_ngcontent-%COMP%]{width:100%;height:100%}"];
export { styles as styles };
